import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Icon from '../icon/Icon';
import { ICONS } from '../icon/Icons';
import { pure } from 'recompose';
import {
  NotificationContainer,
  NotificationHeader,
  NotificationContent,
  NotificationTitle,
  TRANSITION_DURATION,
} from './ui/';

const renderCloseButton = (props) => {
  const {
    onClose
  } = props;
  return (
    <a onClick={onClose}>
      <Icon icon={ICONS.CLOSE_BOLD} width="28px" height="28px" />
    </a>
  );
}

const Modal = (props) => {
  const { children, isOpen, title } = props;
  return (
    <ReactCSSTransitionGroup
      component="div"
      transitionName="modal"
      transitionAppear={true}
      transitionAppearTimeout={TRANSITION_DURATION}
      transitionEnter={true}
      transitionEnterTimeout={TRANSITION_DURATION}
      transitionLeave={true}
      transitionLeaveTimeout={TRANSITION_DURATION}
    >
      {isOpen &&
      <NotificationContainer key="modal" first>
        <NotificationHeader>
          <NotificationTitle>
            {title}
          </NotificationTitle>
          {renderCloseButton(props)}
        </NotificationHeader>
        <NotificationContent>
          { children }
        </NotificationContent>
      </NotificationContainer>
      }
    </ReactCSSTransitionGroup>
  );
};

export default pure(Modal);


// WEBPACK FOOTER //
// ./src/modules/common/components/modal/Notification.js